// One-use, in-memory microphone handoff. Nothing is persisted or put in a URL.
export const voiceAudioConstraints = { audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } };
let pending;
export function releaseVoiceEntry(entry) {
  entry?.stream?.getTracks().forEach(track => track.stop());
  if (entry?.audio) { entry.audio.pause(); entry.audio.srcObject = null; entry.audio.removeAttribute?.('src'); }
}
export function discardVoiceEntry(id) {
  if (!pending || (id && pending.id !== id)) return;
  clearTimeout(pending.timer); releaseVoiceEntry(pending); pending = undefined;
}
export function storeVoiceEntry(entry) {
  discardVoiceEntry();
  const id = window.crypto?.randomUUID?.() || `voice-${Date.now()}-${Math.random()}`;
  pending = {...entry, id, timer:setTimeout(() => discardVoiceEntry(id), 20000)};
  return id;
}
export function takeVoiceEntry(id) {
  if (!id || pending?.id !== id) return null;
  const entry = pending; pending = undefined; clearTimeout(entry.timer);
  return entry;
}
if (typeof window !== 'undefined') window.addEventListener('pagehide', () => discardVoiceEntry());

// Locally generated audio: no provider request or microphone access for a sound test.
export function soundSample(audible = true) {
  const rate=8000, count=audible?3600:400, bytes=new Uint8Array(44+count*2), view=new DataView(bytes.buffer);
  const text=(offset,value)=>[...value].forEach((c,i)=>view.setUint8(offset+i,c.charCodeAt(0)));
  text(0,'RIFF');view.setUint32(4,bytes.length-8,true);text(8,'WAVE');text(12,'fmt ');
  view.setUint32(16,16,true);view.setUint16(20,1,true);view.setUint16(22,1,true);view.setUint32(24,rate,true);view.setUint32(28,rate*2,true);view.setUint16(32,2,true);view.setUint16(34,16,true);text(36,'data');view.setUint32(40,count*2,true);
  for(let i=0;i<count;i++)view.setInt16(44+i*2,audible?Math.round(Math.sin(i/rate*2*Math.PI*660)*Math.sin(Math.PI*i/count)*3500):0,true);
  return 'data:audio/wav;base64,'+btoa(String.fromCharCode(...bytes));
}
